// extracted by mini-css-extract-plugin
export default {"bcHeader":"bc-header-logo_bcHeader__g2Ui-"};